export const cardStyle = {
  backgroundColor: 'white',
  display: 'flex',
  borderRadius: '8px',
  border: '1px solid lightgrey',
};

export const cardTitleStyle = {
  fontSize: 16,
  fontWeight: 700,
  color: 'black',
};

export const cardSubtitleStyle = {
  fontSize: 16,
  fontWeight: 400,
  color: 'grey',
};

export const buttonGroupDeselectedStyle = {
  margin: 2,
  color: 'black',
  borderRadius: '8px',
  backgroundColor: 'transparent',
  textTransform: 'none' as const,
};

export const buttonGroupSelectedStyle = {
  margin: 2,
  color: 'black',
  borderRadius: '8px',
  backgroundColor: 'white',
  textTransform: 'none' as const,
};

export const simpleCharacterButtonStyle = {
  color: 'black',
  fontWeight: 600
}